module.exports = __webpack_public_path__ + "7119f3c6a68da08169020cc5a02ad555.fbx";